import { ReactElement } from 'react';
export const StreamlinesUser = ({ fill = 'none', stroke = 'currentColor' }: any): ReactElement => {
  return (
    <svg x="0px" y="0px" width={'24px'} height={'24px'} viewBox="0 0 36 36">
      <path
        fill={'none'}
        stroke={'currentColor'}
        strokeWidth="1.5"
        d="M12.74.99c3.81,0,6.9,3.09,6.9,6.9s-3.09,6.9-6.9,6.9-6.9-3.09-6.9-6.9S8.93.99,12.74.99Z"
      />
      <circle {...{ stroke, fill: 'none' }} strokeWidth="1.5" strokeMiterlimit="10" cx="13.667" cy="8.709" r="6.897" />
      <path
        {...{ stroke, fill }}
        strokeWidth="1.9"
        strokeMiterlimit="10"
        d="M1.913,28.156
		c0-6.741,5.457-12.198,12.2-12.198"
      />
      <path
        {...{ stroke, fill }}
        strokeWidth="1.9"
        strokeMiterlimit="10"
        d="M25.936,28.156
		c0-6.741-5.455-12.198-12.199-12.198"
      />
    </svg>
  );
};
